import { render, staticRenderFns } from "./roleAuthority.vue?vue&type=template&id=38a63836&"
import script from "./roleAuthority.vue?vue&type=script&lang=js&"
export * from "./roleAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports